module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"reset":"Reset"},"si":{"reset":"Reset"},"ta":{"reset":"Reset"}}')
  delete Component.options._Ctor
}
